import React, { useMemo } from 'react'
import RosterComponent from 'src/supportPortal/components/common/roster/RosterComponent'
import { buildNewRosterRequest } from 'src/supportPortal/components/common/roster/utils'
import MyClinicRosterForm from './components/MyClinicRosterForm'
import MyCurrentRosterSlotViewer from './components/MyCurrentRosterSlotViewer'
import useMentorClinicRosterData from 'src/mentor/components/MentorClinicBookingsPage/component/roster/hooks/useMentorClinicRosterData'

const MyCurrentClinicRoster = React.memo(function MyCurrentClinicRoster({
  roomId,
  mentorProfile,
  clinicLocationId,
  clinicBrandId,
  clinicLocationSchedule,
}) {
  const { chamberRooms, sidebarLegends } = useMentorClinicRosterData(mentorProfile, roomId)

  if (!chamberRooms?.length) {
    return <div>Room ID is not available</div>
  }
  return (
    <RosterComponent
      loadingData={false}
      getOptionLabel={(optn) =>
        `${optn?.clinicBrandName} ${optn?.clinicLocationName} ${optn?.title}`
      }
      getOptionValue={(optn) => optn?.id}
      rosterListFetchApiSignature="/api/secure/teacher/clinic-roster"
      itemOptions={chamberRooms}
      getSidebarLegendItems={(room) => sidebarLegends}
      getSidebarLegendLabel={(leg) => leg?.title}
      getSidebarLegendValue={(leg) => leg?.id}
      legendTitle="Mentors"
      hideLegends
      hideOptionSelectionDropDown
      rosterApiIdParamKey="roomId"
      sidebarLegends={sidebarLegends}
      getSidebarItemReferenceFromRosterItem={(rosterItem) => rosterItem?.mentorId}
      getSelectedItemSchedules={() => clinicLocationSchedule || []}
      selectedItem={chamberRooms?.[0]}
      setSelectedItem={(item) => {}}
      canUserSelectRosterItemMethod={(rosterItem) => {
        return rosterItem?.mentorId === mentorProfile?.id
      }}
      RosterFormComponent={MyClinicRosterForm}
      RosterSlotViewComponent={MyCurrentRosterSlotViewer}
      blockedText="Slot assigned to someone else"
      rosterRequestBuilder={({
        startTimeString,
        endTimeString,
        currentDateString,
        selectedItem,
      }) => {
        return buildNewRosterRequest(
          clinicBrandId,
          clinicLocationId,
          selectedItem?.id,
          mentorProfile?.id,
          currentDateString,
          startTimeString,
          endTimeString,
        )
      }}
    />
  )
})

export default MyCurrentClinicRoster
